import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/eid-fatr.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
import moment from 'moment-hijri';

const TITLE = "Décompte jusqu'à l'Aïd al-Fitr 2027 - Jours restants jusqu'à l'Aïd al-Fitr 2027";
const DESCRIPTION = "Décompte jusqu'à l'Aïd al-Fitr 2027 : combien de jours jusqu'à l'Aïd ? Quand est l'Aïd al-Fitr ? Date de l'Aïd al-Fitr 2027, décompte Aïd al-Fitr, minuterie de décompte, jours restants jusqu'à l'Aïd al-Fitr, célébration de la fin du Ramadan.";
const KEYWORDS = "décompte Aïd al-Fitr 2027, Aïd al-Fitr date, Aïd al-Fitr 2027, jours restants Aïd al-Fitr, décompte fin du Ramadan";
const OG_URL = "https://do-calculate.com/articles-fr/eid-fatr";

function EidFatr() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const [eidDates] = useState([
        { name: "Aïd al-Fitr 2026", date: new Date("2026-03-20T00:00:00") },
        { name: "Aïd al-Fitr 2027", date: new Date("2027-03-10T00:00:00") },
        { name: "Aïd al-Fitr 2028", date: new Date("2028-02-27T00:00:00") },
        { name: "Aïd al-Fitr 2029", date: new Date("2029-02-15T00:00:00") },
    ]);

    const nextEid = eidDates.find(d => new Date() < d.date) || eidDates[eidDates.length - 1];
    const dayName = nextEid.date.toLocaleDateString('fr-FR', { weekday: 'long' });

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(nextEid.date));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(nextEid.date));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, nextEid]);

    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">
                Décompte jusqu'à l'Aïd al-Fitr {nextEid.name.split(' ')[3]}
            </h1>
            <div>
                <BlinkingText
                    text={`Décompte jusqu'à l'Aïd al-Fitr : l'Aïd al-Fitr ${nextEid.name.split(' ')[3]} devrait avoir lieu le ${dayName} ${nextEid.date.toLocaleDateString('fr-FR')} (grégorien) et le ${moment(nextEid.date).format('iDD/iMM/iYYYY')} (hégirien).`}
                />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h2 className="p-3 mb-2 bg-success text-white" style={{ fontSize: '28px', textAlign: 'center' }}>
                        Prochaines dates de l'Aïd al-Fitr
                    </h2>
                    <table style={{ fontSize: '20px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f2f2f2' }}>
                                <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Aïd al-Fitr</th>
                                <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                                <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jours restants</th>
                            </tr>
                        </thead>
                        <tbody>
                            {eidDates.map((eid, index) => (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                    <td style={{ padding: '12px' }}>{eid.name}</td>
                                    <td style={{ padding: '12px' }}>{eid.date.toLocaleDateString('fr-FR')}</td>
                                    <td style={{ padding: '12px' }}>
                                        {Math.max(0, calculateTimeLeft(eid.date).days ?? 0)} jours
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="col-sm-4 col-md-4">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Jours restants jusqu'à l'Aïd al-Fitr 2027</h3>
                    <p>
                        Dans cet article, nous vous présentons le décompte détaillé pour l'Aïd al-Fitr, afin que vous puissiez toujours être informé du nombre de jours restants jusqu'à l'arrivée de cette fête bénie. L'Aïd al-Fitr marque la fin du mois sacré du Ramadan et est une occasion de joie et de célébration pour tous les musulmans.
                    </p>
                    <p>
                        Selon le calendrier hégirien, l'Aïd al-Fitr {nextEid.name.split(' ')[3]} tombera le {dayName} {nextEid.date.toLocaleDateString('fr-FR')} (grégorien) et le {moment(nextEid.date).format('iDD/iMM/iYYYY')} (hégirien).
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Calculer les jours restants jusqu'à l'Aïd al-Fitr
                    </h3>
                    <p>
                        Grâce au programme de décompte de l'Aïd al-Fitr, vous pouvez savoir combien de jours restent jusqu'à cette fête dans les calendriers grégorien et hégirien.
                    </p>
                    <h3 className="p-3 mb-2 bg-success text-white">L'Aïd al-Fitr</h3>
                    <p>
                        L'Aïd al-Fitr (fête de la rupture du jeûne), également connu sous le nom de Petite Fête, est célébré le premier jour de Shawwal, le dixième mois du calendrier islamique, marquant la fin du Ramadan. Cette fête est l'une des deux grandes fêtes islamiques et est attendue avec impatience par les musulmans du monde entier.
                    </p>
                    <p>
                        L'Aïd al-Fitr est un moment de joie, de gratitude envers Dieu pour avoir aidé les croyants à traverser le mois de jeûne, et de générosité envers les moins fortunés. La Zakat al-Fitr (aumône obligatoire de fin de Ramadan) est distribuée avant la prière de l'Aïd pour permettre à tous les musulmans de participer à la fête.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Décompte jusqu'à l'Aïd al-Fitr" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Comment est célébrée l'Aïd al-Fitr ?
                    </h3>
                    <p>
                        La célébration de l'Aïd al-Fitr comprend plusieurs traditions :
                    </p>
                    <ul>
                        <li>Prise d'un bain et port de nouveaux vêtements</li>
                        <li>Prière spéciale de l'Aïd à la mosquée ou en plein air</li>
                        <li>Distribution de la Zakat al-Fitr aux pauvres</li>
                        <li>Échange de vœux "Aïd Moubarak" (Bonne fête)</li>
                        <li>Repas festifs en famille et entre amis</li>
                        <li>Cadeaux aux enfants</li>
                        <li>Visites à la famille et aux proches</li>
                    </ul>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default EidFatr;
